
import hanson from 'hanson';

import Log from '../log';
let log = Log.getLogger('MultiSceneForApp.utils.loadJsonFromText');

export default function loadJsonFromText(text, callback) {

    let error;
    let result;

    try {
        result = hanson.parse(text);
    } catch (e) {
        log.error('Parse error.', text);
        log.error(e);
        error = e;
    }
    callback(error, result);
}
